import * as angular from "angular";
import { CanvassStatusDataProvider } from "../../data-provider/canvass-status.dp";
import { ConsentTypeDataProvider } from "../../data-provider/consent-type.dp";
import { FieldDataProvider } from "../../data-provider/field.dp";
import { Feature } from "../../models/feature.model";
import { FeatureService } from "../../services/feature.service";
import { PermissionCheck } from "../../shared/permission";
import { SurveyDataProvider } from "../../data-provider/survey.dp";
import { TalkingPointDataProvider } from "../../data-provider/talking-point.dp";
import SignaturePad from "signature_pad";

let AndroidMockupComponent = {
    selector: "vcAndroidMockup",
    templateUrl: "/angular/components/customize/android-mockup.component.html",
    restrict: "EA",
    replace: true,
    bindings: {
        permission: "=",
        feature: "=",
        tab: "=",
    },
    controller: class AndroidMockupController {
        // * bindings for typescript compiler *
        public permission: any;
        public feature: any;
        public tab: any;
        // ************************************

        public reception;
        public ratingNames;
        public loading;
        public surveys;
        public signatureFeature;
        public signature;
        public consentTypes;
        public talkingPointCategories;

        private $scope: any;
        private surveyDataProvider: SurveyDataProvider;
        private consentTypeDataProvider: ConsentTypeDataProvider;
        private talkingPointDataProvider: TalkingPointDataProvider;
        private featureService: FeatureService;
        public permissionProvider: PermissionCheck;
        public fieldDataProvider: FieldDataProvider;
        public canvassStatusDataProvider: CanvassStatusDataProvider;

        private $q: any;
        private $anchorScroll: any;
        private $location: any;
        public __env: any;

        constructor(
            __env: any,
            $scope: any,
            $location: any,
            $anchorScroll: any,
            $q: any,
            PermissionCheck: PermissionCheck,
            FieldDataProvider: FieldDataProvider,
            CanvassStatusDataProvider: CanvassStatusDataProvider,
            SurveyDataProvider: SurveyDataProvider,
            ConsentTypeDataProvider: ConsentTypeDataProvider,
            TalkingPointDataProvider: TalkingPointDataProvider,
            FeatureService: FeatureService
        ) {
            this.$q = $q;
            this.$scope = $scope;
            this.$location = $location;
            this.$anchorScroll = $anchorScroll;
            this.featureService = FeatureService;
            this.permissionProvider = PermissionCheck;
            this.fieldDataProvider = FieldDataProvider;
            this.canvassStatusDataProvider = CanvassStatusDataProvider;
            this.surveyDataProvider = SurveyDataProvider;
            this.consentTypeDataProvider = ConsentTypeDataProvider;
            this.talkingPointDataProvider = TalkingPointDataProvider;
            this.__env = __env;
            this.reception = 4;
            this.ratingNames = {
                1: "veryUnlikely",
                2: "unlikely",
                3: "neutral",
                4: "likely",
                5: "veryLikely",
            };

            this.permissionProvider.getConsentSettings().then((settings) => {
                this.signatureFeature = new Feature(
                    this.$q,
                    this.featureService,
                    settings.SIGNATURE.attributes
                );
            });

            this.consentTypeDataProvider.all();

            this.talkingPointDataProvider.getCategories().then((categories) => {
                this.talkingPointCategories = categories;
            });
        }

        $onInit() {
            this.$scope.$watch(
                () => this.tab,
                () => {
                    if (["rating", "fields", "surveys"].includes(this.tab)) {
                        this.$location.hash(this.tab + "-mockup-section");
                        this.$anchorScroll();
                        setTimeout(() => {
                            this.$location.hash(this.tab + "-mockup-section");
                            this.$anchorScroll();
                        }, 100);
                    }
                },
                true
            );

            this.surveyDataProvider.getSurveyLists().then((surveys) => {
                this.loading = false;
                this.surveys = surveys;
            });

            this.signature = {
                canvas: null,
                signaturePad: null,
                clearButton: null,
                init: function () {
                    this.canvas = document.querySelector(".signature-pad");
                    this.clearButton = document.getElementById("clear");
                    this.signaturePad = new SignaturePad(this.canvas);
                    this.clearButton.addEventListener("click", () =>
                        this.signaturePad.clear()
                    );
                },
            };
        }
    },
};

angular
    .module("customize", [])
    .component(AndroidMockupComponent.selector, AndroidMockupComponent);
